export default __webpack_public_path__ + "static/media/circular-logo.0f69251f.svg";